<!-- src/components/common/AlertModal.vue - 完整修复版 -->
<template>
	<div class="modal fade" id="alertModal" tabindex="-1" aria-labelledby="alertModalLabel" aria-hidden="true" data-bs-backdrop="static">
		<div class="modal-dialog modal-dialog-centered">
			<div
				class="modal-content"
				:class="{
					shareSuccess: alertType === 'shareSuccess',
					alertDanger: alertType === 'alertDanger',
					error: alertType === 'error'
				}"
			>
				<div class="modal-body text-center">
					<!-- 分享成功 -->
					<div v-if="alertType === 'shareSuccess'">
						<div class="close-icon" @click="handleCancel()">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
								<line x1="1.0718" y1="15.6488" x2="15.6605" y2="1" stroke="white" stroke-width="2" stroke-linecap="round" />
								<line
									x1="1"
									y1="-1"
									x2="21.543"
									y2="-1"
									transform="matrix(-0.709755 -0.704449 0.751015 -0.660285 17.0747 15.9434)"
									stroke="white"
									stroke-width="2"
									stroke-linecap="round"
								/>
							</svg>
						</div>
						<p class="alert-message">{{ alertMessage }}</p>
						<div class="d-flex flex-column gap-2">
							<div class="shareSuccess-content">
								<h5 class="shareSuccess-text">恭喜獲得<br />Vespa限定好禮抽獎機會</h5>
								<p>將於活動結束後2026/10/22 (四)<br />抽出幸運得主<br />並公布於Vespa官方商城<br />最新消息和Vespa(TW)粉絲專頁​</p>
							</div>
							<div class="shareSuccess-content pt-3">
								<h5 class="shareSuccess-text">更近一步感受你的Vespa</h5>
								<p>立即預約賞車<br />親自體驗專屬於你的騎乘風格​</p>
							</div>
						</div>
						<div class="buttons d-flex flex-column justify-content-around">
							<!-- <button type="button" class="btn btn-primary flex-fill" @click="handleConfirm">確定</button> -->
							<button type="button" class="btn mt-2" style="" @click="handleConfirm"><p>預約賞車</p></button>
						</div>
					</div>

					<!-- 錯誤 - 有確定按鈕 -->
					<div v-else-if="alertType === 'alertDanger'">
						<p class="mt-4 mb-2 alert-message-danger" v-html="formatErrorMessage(alertMessage)"></p>

						<div v-if="hasErrorDetails" class="error-details ">
							<!-- <p class="error-title">詳細信息：</p> -->
							<div class="error-item text-center">
								{{ errorDetails }}
							</div>
						</div>
						<button type="button" class="btn mt-1" @click="handleConfirm"><p>確定</p></button>
					</div>

					<!-- 錯誤 - 無按鈕，只能按關閉 -->
					<div v-else-if="alertType === 'error'">
						<div class="close-icon" @click="handleCancel()">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
								<line x1="1.0718" y1="15.6488" x2="15.6605" y2="1" stroke="white" stroke-width="2" stroke-linecap="round" />
								<line
									x1="1"
									y1="-1"
									x2="21.543"
									y2="-1"
									transform="matrix(-0.709755 -0.704449 0.751015 -0.660285 17.0747 15.9434)"
									stroke="white"
									stroke-width="2"
									stroke-linecap="round"
								/>
							</svg>
						</div>
						<!-- <h5 class="mt-3 mb-3 modal-title text-danger">錯誤</h5> -->
						<p class="alert-message-danger" v-html="formatErrorMessage(alertMessage)"></p>

						<div v-if="hasErrorDetails" class="error-details">
							<!-- <p class="error-title">詳細信息：</p> -->
							<div v-for="(errorArray, fieldName) in errorDetails" :key="fieldName" class="error-item">
								<div v-for="(errorMsg, index) in formatErrorArray(errorArray)" :key="index" class="error-message">{{ errorMsg }}</div>
							</div>
						</div>
					</div>

					<!-- 一般提示 (預設) -->
					<div v-else>
						<p class="alert-message">{{ alertMessage }}</p>
													<div v-for="(errorArray, fieldName) in errorDetails" :key="fieldName" class="error-item">
								<div v-for="(errorMsg, index) in formatErrorArray(errorArray)" :key="index" class="error-message">{{ errorMsg }}</div>
							</div>
						<button type="button" class="btn mt-1" @click="handleConfirm"><p>確定</p></button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'
import { Modal } from 'bootstrap'
import APP_CONFIG from '@/config/config'
import { useStore } from '@/stores/index'

const store = useStore()
const alertType = ref('')
const alertMessage = ref('')
const alertData = ref({})
const confirmCallback = ref(null)
const cancelCallback = ref(null)
const modalInstance = ref(null)

/* ---- 錯誤訊息處理 ---- */
const errorDetails = computed(() => {
	if (alertData.value?.errors && Object.keys(alertData.value.errors).length > 0) {
		return alertData.value.errors
	}

	if (alertData.value?.data && typeof alertData.value.data === 'object') {
		return Object.fromEntries(Object.entries(alertData.value.data).map(([key, value]) => [key, Array.isArray(value) ? value : [value]]))
	}

	return null
})

const hasErrorDetails = computed(() => {
	return errorDetails.value && Object.keys(errorDetails.value).length > 0
})

const formatErrorArray = (errorValue) => {
	if (Array.isArray(errorValue)) {
		return errorValue
	}
	return [errorValue]
}

const formatErrorMessage = (message) => {
	if (!message) return ''
	return message.replace(/[,，]/g, '$&<br>')
}

/* ---- API ---- */
const show = async (type = '', message = '', data = {}, callback = null, cancelCb = null) => {
	alertType.value = type
	alertMessage.value = message
	alertData.value = data
	confirmCallback.value = callback
	cancelCallback.value = cancelCb

	const modalElement = document.getElementById('alertModal')

	if (modalElement) {
		// 如果已經有 modal 實例
		if (modalInstance.value) {
			if (modalElement.classList.contains('show')) {
				// Modal 已經在顯示，只需更新內容，不需要再次調用 show()
			} else {
				try {
					modalInstance.value.show()
				} catch (err) {
					console.error('  ❌ 顯示失敗:', err)
				}
			}
		} else {
			// 第一次建立 modal 實例
			try {
				modalInstance.value = new Modal(modalElement, {
					backdrop: 'static',
					keyboard: false
				})

				modalInstance.value.show()
			} catch (err) {
				console.error('  建立或顯示失敗:', err)
			}
		}
	} else {
		console.error('  ❌ 找不到 #alertModal 元素！')
	}
}

const hide = () => {
	return new Promise((resolve) => {
		if (modalInstance.value) {
			try {
				modalInstance.value.hide()
				// ⏳ 等待 Bootstrap modal 隐藏动画完成（约 300-350ms）
				setTimeout(() => {
					resolve()
				}, 350)
			} catch (err) {
				console.error('  ❌ hide 失敗:', err)
				resolve()
			}
		} else {
			resolve()
		}
	})
}

const handleConfirm = async () => {
	try {
		if (confirmCallback.value && typeof confirmCallback.value === 'function') {
			const result = confirmCallback.value()

			if (result instanceof Promise) {
				await result
				store.stopLoading()
			} else {
				store.stopLoading()
			}
		}
	} catch (err) {
		console.error('  ❌ callback 執行出錯:', err)
	}

	// ✅ 改成 await - 等待 modal 完全隱藏
	await hide()
}

const handleCancel = async () => {
	try {
		if (cancelCallback.value && typeof cancelCallback.value === 'function') {
			const result = cancelCallback.value()
			if (result instanceof Promise) {
				await result
			} else {
			}
		}
	} catch (err) {
		console.error('  ❌ cancelCallback 執行出錯:', err)
	}
	await hide()
}

defineExpose({ show, hide })
</script>

<style lang="scss" scoped>
.modal {
	height: 100%;
	background-color: rgba(0, 0, 0, 0.6);
	backdrop-filter: blur(0px);
	.modal-dialog {
		margin: 0 auto;
	}

	.modal-content {
		border-radius: 0%;
		border: none;
		margin: 1.75rem;
		// padding: 1.1rem;
		overflow-y: visible;
		overflow-x: visible;
		position: relative;
		border-radius: 15px;
		z-index: 0;

		.modal-body {
			padding: 1.75rem 2.25rem 0.6rem;
			min-height: 2rem;
			position: relative;
			border-radius: 15px;
			background:
				linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),
				lightgray url('https://lineevent.s3.ap-northeast-1.amazonaws.com/Vespa_New180/images/bg/bg.png') 50% / cover no-repeat;

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				width: 100%;
				height: 1.8rem;
				border-radius: 15px 15px 0 0;
				background: linear-gradient(180deg, #abc7c9 0%, #6eb9bc 100%);
			}
			.close-icon {
				position: absolute;
				background-image: none;
				display: inline-block;
				top: 0%;
				right: 4%;
			}

			.modal-title {
				width: 160px;
				margin: auto;
				font-weight: 700;
				color: #1e1e1e;

				span {
					color: #f7931d;
					font-family: 'Montserrat';
					font-size: 2em;
					font-style: normal;
					font-weight: 700;
					line-height: 24px;
				}
			}

			.text-warn {
				color: #000;
				text-align: center;
				font-size: 0.8em;
				font-style: normal;
				font-weight: 400;
				line-height: 1.2em;
			}

		}
	}
}

.alert-message {
	padding: 1.3rem 0 0.825rem 0;
	color: #000;
	text-align: center;
	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 28px; /* 116.667% */
	letter-spacing: 0.96px;
	margin: 0;
}

.alert-message-danger {
	margin: 3em 0;
	color: #000;
	font-weight: 500;
	font-size: 1em;
	line-height: 1.5;
	word-break: break-word;
	white-space: normal;
}

.error-details {
	margin: 0.6em auto;
	max-height: 15em;
	overflow-y: auto;
	text-align: left;

	.error-title {
		font-size: 12px;
		color: #000;
		margin: 0 0 8px 0;
		font-weight: 600;
		text-align: center;
	}

	.error-item {
		margin-bottom: 8px;
		padding-bottom: 8px;
		// border-bottom: 1px solid rgba(252, 198, 3, 0.3);

		&:last-child {
			margin-bottom: 0;
			padding-bottom: 0;
			border-bottom: none;
		}
	}

	.error-message {
		font-size: 0.8em;
		text-align: center;
		margin: auto;
		color: #000;
		// margin: 2px 0;
		// padding-left: 8px;
		line-height: 1.4;
	}
}

.btn {
	width: 100%;
	height: auto;
	border-radius: 12px;
	font-size: 16px;
	font-weight: 600;
	min-width: 100px;
	color: #fff;
	text-align: center;
	font-size: 1rem;
	font-style: normal;
	font-weight: 700;
	line-height: 73px;
	letter-spacing: 0.8px;
	padding: 0;

	// 移除焦點和選中狀態邊框
	&:focus,
	&:focus-visible,
	&:focus-within,
	&:active {
		outline: none !important;
		border: transparent !important;
		box-shadow: none !important;
	}
	p {
		color: #fff;
		font-style: normal;
		font-weight: 700;
		line-height: normal;
		letter-spacing: 0.5px;
		padding: 0;
		margin: 0;
		position: absolute;
		top: 40%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}

.btn-primary {
	color: #fff;
	font-size: 0.9em;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	// border-radius: 12px;
	background: linear-gradient(90deg, #fbc143 0%, #ff9c00 100%);
	box-shadow:
		-1px -1px 2px 0 rgba(108, 67, 0, 0.4) inset,
		2px 2px 5px 0 #fff inset;
	border: 1px solid transparent;
	width: calc(100% - 2.4em);
	margin: 0em 1.2em;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(241, 90, 34, 0.4);
	}

	// 移除焦點和選中狀態的邊框
	&:focus,
	&:focus-visible,
	&:focus-within,
	&:active,
	&:active:focus {
		outline: none !important;
		border: 1px solid transparent !important;
		box-shadow:
			-1px -1px 2px 0 rgba(108, 67, 0, 0.4) inset,
			2px 2px 5px 0 #fff inset !important;
	}
}

.registerSuccess-p {
	padding: 2.91em 0em 3.2em 0em;
	margin: 0;
}

.modal-content.shareSuccess {
	.shareSuccess-content {
		padding: 0.5rem 0.91rem 1rem;
		border-radius: 10px;
		background: rgba(255, 255, 255, 0.5);
		box-shadow:
			0 4px 10px 0 rgba(33, 183, 50, 0.1),
			4px 5px 14.7px var(--sds-size-depth-100) rgba(255, 255, 255, 0.69) inset;
		backdrop-filter: blur(8.550000190734863px);

		h5.shareSuccess-text {
			color: #638c8d;
			text-align: center;
			font-size: 16px;
			font-style: normal;
			font-weight: 700;
			line-height: 22px; /* 137.5% */
			letter-spacing: 0.64px;
			padding: 0 0 0.5rem 0;
			border-bottom: 1px solid rgba(0, 0, 0, 0.18);
		}
		p {
			color: #5d5c5c;
			font-style: normal;
			font-weight: 400;
			line-height: 20px;
			color: rgba(40, 40, 40, 0.75);
			text-align: center;
			font-size: 0.7rem;
			font-style: normal;
			font-weight: 400;
			line-height: 1.1rem;
			margin: 0;
		}
	}
}

// checkRedeem 樣式
.modal-content.checkRedeem {
	width: 16em;
	margin: auto;
	position: relative;
	overflow: visible;

	.modal-body {
		img {
			position: absolute;
			top: -38%;
			left: 50%; // ✅ 添加这行
			transform: translateX(-50%); // ✅ 添加这行 - 水平居中
			width: 14em;
		}

		.modal-title {
			margin-top: 2.5em;
			color: #000;
			font-family: 'Noto Sans TC';
			font-size: 20px;
			font-style: normal;
			font-weight: 700;
			line-height: 24px; /* 120% */
		}

		.text-warn {
			color: #000;
			text-align: center;
			font-size: 0.8em;
			font-style: normal;
			font-weight: 400;
			line-height: 1.8em;
		}

		.cancel {
			width: 2em; // 你要的固定寬度
			white-space: nowrap; // 避免換行
			text-align: center; // 置中顯示
			color: #1e1e1e;
			font-size: 0.8em;
			font-weight: 400;
			background: transparent;
			border: none;
			cursor: pointer;
			margin: 0 auto;

			border-bottom: 1px solid #1e1e1e; // 底線 OK
			padding-bottom: 2px; // 讓底線與字有更好距離（可選）
			&:hover {
				text-decoration: underline;
			}

			&:focus {
				outline: none !important;
			}
		}

		.buttons {
			height: 5.05em;
			gap: 0.8em;
			margin-top: 1.6em;
		}
	}
}


// redeemSuccess 樣式
.modal-content.redeemSuccess {
	.modal-body {
		padding: 1.3em;

		.text-warn {
			margin-bottom: 2.3em;
		}
	}
}

.btn-img {
	background-repeat: no-repeat;
	background-size: contain;
}

@media (min-width: 768px) {
	.modal .modal-content {
		margin: 0;
	}
	.modal .modal-content .modal-body {
		padding: 1.2rem;
	}
}
</style>
